import React from 'react';
import { NODE_PALETTE } from './types';
import type { NodeType } from './types';

interface NodePaletteProps {
  onAddNode: (nodeType: NodeType) => void;
}

export const NodePalette: React.FC<NodePaletteProps> = ({ onAddNode }) => {
  const onDragStart = (event: React.DragEvent, nodeType: NodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div className="w-48 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 p-3 overflow-y-auto">
      <h3 className="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-3 flex items-center gap-1.5">
        <span>🎨</span>
        Componentes
      </h3>

      <div className="space-y-2">
        {NODE_PALETTE.map((node) => (
          <div
            key={node.type}
            draggable
            onDragStart={(e) => onDragStart(e, node.type)}
            onClick={() => onAddNode(node.type)}
            className={`
              ${node.color} text-white
              p-3 rounded-lg cursor-move
              hover:opacity-90 transition-opacity
              shadow-md
            `}
            title={node.description}
          >
            <div className="flex items-center gap-2">
              <span className="text-xl">{node.icon}</span>
              <div className="flex-1">
                <div className="font-semibold text-sm">{node.label}</div>
                <div className="text-xs opacity-75 mt-0.5">{node.description}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 space-y-2">
        <div className="p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
          <p className="text-xs text-blue-700 dark:text-blue-300">
            <strong>💡 Dica:</strong> Arraste os componentes para o canvas ou clique para adicionar.
          </p>
        </div>
        <div className="p-3 bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg">
          <p className="text-xs text-purple-700 dark:text-purple-300">
            <strong>🔗 Conexões:</strong> Duplo clique em uma linha para configurar condições e prioridade.
          </p>
        </div>
      </div>
    </div>
  );
};
